// extracted by mini-css-extract-plugin
module.exports = {"attendeeForm":"AttendeeForm_attendeeForm__3ujK0","column1":"AttendeeForm_column1__10M9B","column2":"AttendeeForm_column2__naokj"};